import { CheckBox, DatePicker, TextBox } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";

export const TaskCustomFieldType = ({ customField, onChange, fieldValue }) => {
  const { i18n } = useTranslation(["CreateTaskModal"]);

  const fieldId = customField?.Id;

  switch (customField.Type) {
    case 0: // Text
      return (
        <TextBox
          name={customField?.Label}
          labelText={customField?.Label}
          id={`text-box-${fieldId}`}
          value={fieldValue}
          change={(e) => onChange(fieldId, e.value)}
        />
      );
    case 1: // Number
      return (
        <div className="custom-field-textbox">
          <TextBox
            name={customField?.Label}
            labelText={customField?.Label}
            id={`text-box-${fieldId}`}
            value={fieldValue}
            change={(e) => onChange(fieldId, e.value)}
            type="number"
          />
        </div>
      );
    case 2: // Date
      return (
        <div className="custom-field-date-picker">
          <DatePicker
            id={`date-picker-${fieldId}`}
            labelText={customField?.Label}
            language={i18n.language}
            value={fieldValue}
            change={(e) => onChange(fieldId, e.value)}
          />
        </div>
      );
    case 3: // Checkbox
      return (
        <CheckBox
          id={`checkbox-${fieldId}`}
          label={customField?.Label}
          checked={fieldValue}
          change={(e) => onChange(fieldId, e.checked)}
        />
      );
  }
};
